<template>
  <div class="history-view">
    <section class="site-hero history-hero" :style="heroStyle">
      <div class="site-hero__inner hero-grid">
        <div>
          <h1>发展历程</h1>
          <p v-for="(paragraph, index) in pageIntro" :key="index">{{ paragraph }}</p>
        </div>
      </div>
    </section>

    <section class="page-section content-section">
      <div class="page-head">
        <div><h2>时间轴总览</h2></div>
        <!-- <p class="page-note">从 2003 年开始至今，以固定宽度横向展示年度节点。点击年份后，页面下方立即切换到对应的大事件内容。</p> -->
      </div>
      <div class="page-shell timeline-shell">
        <div class="timeline-top">
          <button class="timeline-arrow" :disabled="selectedIndex === 0" @click="prevYear">‹</button>
          <div class="timeline-viewport">
            <div class="timeline-track" :style="{ transform: `translateX(-${startIndex * stepWidth}px)` }">
              <button
                v-for="(item, index) in yearGroups"
                :key="item.year"
                class="year-button"
                :class="{ current: index === selectedIndex }"
                @click="selectYear(index)"
              >
                <div class="year-label">
                  <strong>{{ item.year }}</strong>
                  <!-- <span>Year</span> -->
                </div>
                <span class="year-dot"></span>
              </button>
            </div>
          </div>
          <button class="timeline-arrow" :disabled="selectedIndex === yearGroups.length - 1" @click="nextYear">›</button>
        </div>

        <div class="timeline-content">
          <article class="event-card panel-card">
            <h3 class="event-year">{{ currentGroup.year }}</h3>
            <div class="event-list">
              <article v-for="item in currentGroup.events" :key="item.key || item.title" class="event-item">
                <button
                  class="event-title-button"
                  :class="{ linkable: item.articleUrl }"
                  :disabled="!item.articleUrl"
                  @click="openEvent(item)"
                >
                  {{ item.title }}
                </button>
                <p class="event-summary">{{ item.summary }}</p>
                <div v-if="item.points && item.points.length" class="event-points">
                  <article v-for="point in item.points" :key="point.label">
                    <p>{{ point.text }}</p>
                  </article>
                </div>
              </article>
            </div>
          </article>
          <!-- <aside class="event-side panel-card">
            <h3>{{ currentItem.year }} 年阶段重点</h3>
            <p>{{ currentItem.summary }}</p>
            <div class="year-progress">
              <span>当前年份</span>
              <strong>{{ currentItem.year }} / {{ lastYear }}</strong>
            </div>
          </aside> -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getSitePage } from "@/api/website";

export default {
  name: "HistoryView",
  data() {
    return {
      timelineData: [],
      pageSettings: {
        bannerImage: "/assets/banner.png",
        intro: []
      },
      selectedIndex: 0,
      startIndex: 0,
      stepWidth: 132
    };
  },
  computed: {
    currentItem() {
      return this.timelineData[this.selectedIndex] || { year: "", title: "", summary: "", points: [] };
    },
    yearGroups() {
      const groupMap = {};
      const groups = [];
      this.timelineData.forEach((item) => {
        const year = item.year || "未设置年份";
        if (!groupMap[year]) {
          groupMap[year] = { year, events: [] };
          groups.push(groupMap[year]);
        }
        groupMap[year].events.push(item);
      });
      return groups;
    },
    currentGroup() {
      return this.yearGroups[this.selectedIndex] || { year: "", events: [] };
    },
    lastYear() {
      return this.yearGroups.length ? this.yearGroups[this.yearGroups.length - 1].year : "";
    },
    pageIntro() {
      return this.pageSettings.intro && this.pageSettings.intro.length ? this.pageSettings.intro : [""];
    },
    heroStyle() {
      const image = this.pageSettings.bannerImage || "/assets/banner.png";
      return {
        "--page-banner-image": `url("${image}")`
      };
    }
  },
  created() {
    getSitePage("history").then((res) => {
      const data = res.data || {};
      const pageSettings = data.pageSettings || {};
      this.pageSettings = pageSettings.history || this.pageSettings;
      this.timelineData = data.history || [];
      this.selectedIndex = Math.max(this.yearGroups.length - 1, 0);
      this.updateViewport();
    });
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    visibleCount() {
      if (window.innerWidth <= 680) return 3;
      if (window.innerWidth <= 1040) return 5;
      return 7;
    },
    ensureVisible() {
      const visible = this.visibleCount();
      if (this.selectedIndex < this.startIndex) this.startIndex = this.selectedIndex;
      if (this.selectedIndex > this.startIndex + visible - 1) {
        this.startIndex = this.selectedIndex - visible + 1;
      }
      const maxStart = Math.max(0, this.yearGroups.length - visible);
      this.startIndex = Math.min(Math.max(0, this.startIndex), maxStart);
    },
    updateViewport() {
      if (window.innerWidth <= 680) this.stepWidth = 98;
      else if (window.innerWidth <= 1040) this.stepWidth = 112;
      else this.stepWidth = 132;
      this.ensureVisible();
    },
    selectYear(index) {
      this.selectedIndex = index;
      this.ensureVisible();
    },
    prevYear() {
      if (this.selectedIndex > 0) {
        this.selectedIndex -= 1;
        this.ensureVisible();
      }
    },
    nextYear() {
      if (this.selectedIndex < this.yearGroups.length - 1) {
        this.selectedIndex += 1;
        this.ensureVisible();
      }
    },
    openEvent(item) {
      if (item.articleUrl) {
        window.open(item.articleUrl, "_blank", "noopener");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.history-hero {
  background:
    linear-gradient(90deg, rgba(3, 23, 50, 0.94) 0%, rgba(7, 55, 105, 0.74) 48%, rgba(12, 83, 146, 0.34) 100%),
    var(--page-banner-image) center / cover no-repeat;
}

.hero-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  gap: 28px;
}

.hero-panel {
  align-self: end;
  padding: 26px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
  border-color: rgba(255, 255, 255, 0.14);
  color: var(--white);
}

.hero-panel b {
  display: block;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
}

.hero-panel h3 {
  margin: 0 0 10px;
  font-size: 26px;
}

.hero-panel p {
  margin: 0;
}

.content-section {
  background: var(--soft-blue);
}

.page-shell {
  width: min(1280px, 100%);
  margin: 0 auto;
}

.timeline-shell {
  display: grid;
  gap: 26px;
}

.timeline-top {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 18px;
  align-items: center;
}

.timeline-arrow {
  width: 56px;
  height: 56px;
  border: 0;
  border-radius: 50%;
  background: #fff;
  color: var(--navy);
  font-size: 28px;
  cursor: pointer;
}

.timeline-arrow:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.timeline-viewport {
  overflow: hidden;
  position: relative;
  width: min(924px, 100%);
  margin: 0 auto;
  padding: 12px 0 20px;
}

.timeline-viewport::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 3px;
  background: linear-gradient(90deg, rgba(29, 104, 199, 0.18), rgba(29, 104, 199, 0.42), rgba(29, 104, 199, 0.18));
}

.timeline-track {
  display: flex;
  transition: transform 0.35s ease;
}

.year-button {
  width: 132px;
  min-width: 132px;
  padding: 0 10px;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: grid;
  justify-items: center;
  gap: 12px;
}

.year-label {
  display: grid;
  gap: 6px;
  justify-items: center;
}

.year-label strong {
  font-size: 24px;
}

.year-label span {
  color: var(--muted);
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.year-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid rgba(29, 104, 199, 0.22);
  background: #fff;
}

.year-button.current .year-dot {
  background: var(--blue);
  border-color: rgba(29, 104, 199, 0.88);
  box-shadow: 0 0 0 10px rgba(29, 104, 199, 0.12);
}

.year-button.current .year-label strong,
.year-button.current .year-label span {
  color: var(--navy);
}

.timeline-content {
  display: grid;
  //grid-template-columns: minmax(0, 0.78fr) minmax(280px, 0.52fr);
  gap: 24px;
}

.event-card,
.event-side {
  padding: 26px;
}

.event-list {
  display: grid;
  gap: 22px;
  margin-top: 14px;
}

.event-item + .event-item {
  padding-top: 22px;
  border-top: 1px solid rgba(29, 104, 199, 0.12);
}

.event-mark {
  display: inline-flex;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(29, 104, 199, 0.12);
  color: var(--navy);
  font-weight: 700;
}

.event-year {
  margin: 16px 0 0;
  font-size: clamp(42px, 5vw, 64px);
}

.event-title {
  margin: 10px 0 0;
  font-size: clamp(24px, 3vw, 36px);
}

.event-title-button {
  display: inline;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--navy);
  font: inherit;
  font-size: clamp(22px, 2.4vw, 32px);
  font-weight: 700;
  text-align: left;
  cursor: default;
}

.event-title-button.linkable {
  cursor: pointer;
}

.event-title-button.linkable:hover {
  color: var(--blue);
}

.event-summary {
  margin: 18px 0 0;
  color: #44536b;
}

.event-points {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 20px;
}

.event-points article {
  padding: 18px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96), rgba(240, 245, 255, 0.92));
  border: 1px solid rgba(29, 104, 199, 0.12);
}

.event-points b,
.event-side b {
  color: var(--blue);
  text-transform: uppercase;
}

.event-points p,
.event-side p {
  margin: 8px 0 0;
  color: var(--muted);
}

.event-side h3 {
  margin: 10px 0 0;
  font-size: 24px;
}

.year-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding: 14px 18px;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(29, 104, 199, 0.08), rgba(32, 184, 218, 0.08));
  color: var(--navy);
}

@media (max-width: 1040px) {
  .hero-grid,
  .timeline-content {
    grid-template-columns: 1fr;
  }

  .year-button {
    width: 112px;
    min-width: 112px;
  }
}

@media (max-width: 680px) {
  .year-button {
    width: 98px;
    min-width: 98px;
  }

  .timeline-top {
    gap: 10px;
  }

  .timeline-arrow {
    width: 40px;
    height: 40px;
    font-size: 22px;
  }

  .year-label strong {
    font-size: 19px;
  }

  .event-card,
  .event-side {
    padding: 20px;
  }

  .event-year {
    font-size: 32px;
  }

  .event-title-button {
    font-size: 20px;
  }

  .event-summary,
  .event-points p {
    font-size: 14px;
  }

  .event-points {
    grid-template-columns: 1fr;
  }
}
</style>
